import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import camelcaseKeys from 'camelcase-keys'
import Category from '@src/data/category'

type CategoriesResponse = { categories: Category[] }

export class CategoryService {

  apiClient: ApiClient = new ApiClient()

  getCategories (masterClub: boolean, locale: string) {
    let scope = masterClub ? 'master' : 'club'
    return this.apiClient.get(API.TRAINERS_API.CATEGORIES + '?scope=' + scope)
      .then((response: CategoriesResponse) => {
        let categories: Category[] = []
        response.categories.map((category) => categories.push(new Category(camelcaseKeys(category, { deep: true }))))
        categories = categories.sort((a,b) => {
          let c1 = a.getName(locale).toLocaleUpperCase()
          let c2 = b.getName(locale).toLocaleUpperCase()
          return (c1 > c2) ? 1 : ((c1 < c2) ? -1 : 0)
        })
        return categories
      })
      .catch(error => {
        console.log('cannot load categories ', error)
        return Promise.reject(error)
      })
  }
}
